import { render, staticRenderFns } from "./homepage-hot-drops.vue?vue&type=template&id=45882dd6&scoped=true"
import script from "./homepage-hot-drops.vue?vue&type=script&setup=true&lang=js"
export * from "./homepage-hot-drops.vue?vue&type=script&setup=true&lang=js"
import style0 from "./homepage-hot-drops.vue?vue&type=style&index=0&id=45882dd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45882dd6",
  null
  
)

export default component.exports